import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import TopBar from "./TopBar";
import HomePage from "../pages/HomePage";
import ArticlePage from "../pages/ArticlePage";
import ChatSidebar from "./ChatSidebar";
import ProtectedRoute from "./ProtectedRoute";

export default function DefaultLayout() {
  const [isNewsFeedOpen, setIsNewsFeedOpen] = useState(false);

  const toggleNewsFeed = () => setIsNewsFeedOpen((prev) => !prev);

  return (
    <div className="flex flex-col w-full bg-gradient-to-br from-gray-100 to-white text-gray-900 font-sans">
      <TopBar />

      <div className="flex flex-1 overflow-hidden">
        <ProtectedRoute>
          <ChatSidebar />
        </ProtectedRoute>

        {/* {isNewsFeedOpen && (
          <div className="flex-1 overflow-y-auto p-4">
            <Routes>
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <HomePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/article/:articleId"
                element={
                  <ProtectedRoute>
                    <ArticlePage />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </div>
        )} */}
      </div>

      {/* Toggle button for the news feed */}
      {/* <button
        onClick={toggleNewsFeed}
        className="hidden md:flex fixed top-20 right-4 p-3 bg-white rounded-full shadow-lg hover:shadow-xl transition-all duration-200 group z-50"
        aria-label="Toggle newsfeed"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6 transition-transform duration-200"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d={
              isNewsFeedOpen
                ? "M9 5l7 7-7 7"
                : "M15 19l-7-7 7-7"
            }
          />
        </svg>
      </button> */}
    </div>
  );
}
